// src/hooks/useResizableTable.js
import { useEffect } from "react";

/**
 * テーブル列リサイズ用カスタムフック
 */
const useResizableTable = (headers, folderId) => {

    useEffect(() => {
        const tables = document.querySelectorAll(
            ".document-table__table, .search-table__table"
        );

        if (!tables.length) return;

        tables.forEach((table) => {
            const ths = table.querySelectorAll("th");

            ths.forEach((th) => {
                if (th.querySelector(".resizer")) return;

                th.style.position = "relative";

                const resizer = document.createElement("div");
                resizer.className = "resizer";

                Object.assign(resizer.style, {
                    width: "5px",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    cursor: "col-resize",
                    userSelect: "none",
                    zIndex: 10,
                });

                th.appendChild(resizer);

                let startX, startWidth;
                let isResizing = false; // ⭐ KEY

                const onMouseDown = (e) => {
                    e.stopPropagation();
                    isResizing = true;

                    startX = e.pageX;
                    startWidth = th.offsetWidth;
                    document.body.style.cursor = "col-resize";

                    const onMouseMove = (e) => {
                        const diff = e.pageX - startX;
                        th.style.width = `${startWidth + diff}px`;
                    };

                    const onMouseUp = () => {
                        document.body.style.cursor = "default";
                        isResizing = false;

                        document.removeEventListener("mousemove", onMouseMove);
                        document.removeEventListener("mouseup", onMouseUp);
                    };

                    document.addEventListener("mousemove", onMouseMove);
                    document.addEventListener("mouseup", onMouseUp);
                };

                resizer.addEventListener("mousedown", onMouseDown);

                th.addEventListener("click", (e) => {
                    if (isResizing) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                });

                resizer.addEventListener("click", (e) => {
                    e.stopPropagation();
                });
            });
        });

    }, [headers, folderId]);
};

export default useResizableTable;
